if (!customElements.get('ingredient-search')) {
  class IngredientSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.ingredient-search__input');
      this.clearButton = this.querySelector('.ingredient-search__clear');
      this.count = this.querySelector('.ingredient-search__count');
      this.emptyState = this.querySelector('[data-empty-state]');
      this.cards = Array.from(this.querySelectorAll('[data-ingredient-card]'));

      if (!this.input || !this.cards.length) return;

      this.querySelector('form')?.addEventListener('submit', (event) => event.preventDefault());
      this.input.addEventListener('input', () => this.filter());
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.input.value) this.reset();
      });
      this.clearButton?.addEventListener('click', () => this.reset());
    }

    normalize(value) {
      return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase();
    }

    filter() {
      const query = this.normalize(this.input.value.trim());
      let visibleCount = 0;

      this.cards.forEach((card) => {
        const title = card.querySelector('[data-ingredient-title]')?.textContent || '';
        const matches = !query || this.normalize(title).includes(query);
        card.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      if (this.clearButton) this.clearButton.hidden = !query;
      if (this.emptyState) this.emptyState.hidden = visibleCount !== 0;

      const label = visibleCount === 1 ? this.dataset.singularLabel : this.dataset.pluralLabel;
      if (this.count) this.count.textContent = `${visibleCount} ${label}`;
    }

    reset() {
      this.input.value = '';
      this.filter();
      this.input.focus();
    }
  }

  customElements.define('ingredient-search', IngredientSearch);
}
